/**
 * Section: Footer
 * ------------------------------------------------------------------------------
 * Component file for the 'site-footer' section.
 *
 * @namespace Footer
 */
import './site-footer.scss'

import CountryModal from '~/components/country-modal'
import NewsletterForm from '~components/newsletter-form/newsletter-form'
import CollapsibleBlock from '~components/collapsible-block/collapsible-block'

/**
 * Create a new footer object.
 * @param {HTMLElement} section - Scoped [data-mint-section] <section> element.
 */
export default ({ section = false } = false) => {

  /**
   * Initialise component.
   */
  function init() {
    CountryModal().init()

    if ('customElements' in window && !customElements.get('newsletter-form')) {
      customElements.define('newsletter-form', NewsletterForm)
    }

    if ('customElements' in window && !customElements.get('collapsible-block')) {
      customElements.define('collapsible-block', CollapsibleBlock)
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
